import v1_actionDownloadMediaWhatsapp from 'src/actions/v1/whatsapp/v1_actionDownloadMediaWhatsapp';
import { getImageBlob, initCacheFileSave } from 'src/helpers/cache.helper';

export const downloadMedia = async (message, sessao) => {
    // Midia de pagina Meta (Instagram/Messenger) ja esta re-hospedada no S3 e vem com a
    // URL pronta em mediaUrl. O endpoint de download le a collection do WhatsApp, onde
    // essas mensagens nao existem — chamar de la retorna 400 e o arquivo nunca abre.
    if (message?.isMetaMedia && message?.mediaUrl) {
        return message.mediaUrl;
    }

    const checkBlob = await getImageBlob(message.id);
    if (checkBlob) {
        return checkBlob;
    }

    try {
        const querys = `?sessao=${message.session}&msgId=${message.id}&canal=${message.platform}`;
        const response = await v1_actionDownloadMediaWhatsapp(querys);

        if (response.data.status === "error") {
            throw new Error('Não foi possível baixar a mídia');
        }

        const base64Data = `data:${message.mimetype};base64, ${response.data.data.base64}`;
        initCacheFileSave(message.id, base64Data, message.mimetype);
        
        return base64Data;
    } catch (error) {
        console.error('Erro ao baixar mídia:', error);
        throw error;
    }
}; 